import React from "react";
import { FiUpload, FiFile, FiEye, FiCheckCircle } from "react-icons/fi";

export default function FileUploadAndView({
  activeUpload,
  progress,
  files,
  handleUpload,
  doc,
}) {
  return (
    <div className="text-xs space-y-2">
      <div className="flex items-center justify-between">
        <span className="font-medium text-[#363062]">{doc}</span>
        {files[doc] && (
          <span className="flex items-center gap-1 text-[#8FCD00]">
            <FiCheckCircle className="w-3.5 h-3.5" />
            <span>Uploaded</span>
          </span>
        )}
      </div>

      <div className="border-2 border-dashed border-gray-200 rounded-lg p-4 hover:border-[#363062]/50 transition-colors">
        <input
          type="file"
          onChange={(e) => handleUpload(e, doc)}
          className="hidden"
          id={`file-upload-${doc}`}
          accept=".pdf,.jpg,.jpeg,.png"
        />
        <label
          htmlFor={`file-upload-${doc}`}
          className="cursor-pointer block text-center"
        >
          {files[doc] ? (
            <div className="flex items-center justify-center gap-3">
              <FiFile className="w-5 h-5 text-[#363062]" />
              <div className="flex items-center gap-2">
                <span className="text-gray-600">File uploaded</span>
                <a
                  href={files[doc]}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1 text-[#363062] hover:text-[#363062]/80 transition-colors"
                >
                  <FiEye className="w-3.5 h-3.5" />
                  <span>View</span>
                </a>
              </div>
            </div>
          ) : (
            <div>
              <FiUpload className="w-6 h-6 text-[#363062]/50 mx-auto mb-2" />
              <div className="text-gray-600">
                Click to upload or drag and drop
              </div>
              <div className="text-gray-500 mt-1">
                Supported formats: PDF, JPG, JPEG, PNG
              </div>
            </div>
          )}
        </label>
      </div>

      {activeUpload === doc && progress > 0 && (
        <div>
          <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
            <div
              className="h-full bg-[#8FCD00] transition-all duration-300 rounded-full"
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="text-gray-500 mt-1 text-center">
            Uploading... {Math.round(progress)}%
          </div>
        </div>
      )}
    </div>
  );
}